function LocalJsonResource(data) {
  this.get = () => {
    return data;
  };
}

export default LocalJsonResource;
